@if (visible) {
  <div class="ajustes-security-panel pin-panel">
    <div class="ajustes-security-panel__header">
      <div class="ajustes-security-panel__icon">
        <i class="material-icons" aria-hidden="true">dialpad</i>
      </div>

      <div class="ajustes-security-panel__copy">
        <strong>PIN de autorización</strong>
        <span>Lo pide COS al firmar dictámenes y otras autorizaciones.</span>
      </div>
    </div>

    <div class="pin-panel__estado">
      <span class="ajustes-inline-badge" [class.is-ok]="tienePin && !bloqueadoHasta" [class.pin-panel__badge--mal]="!!bloqueadoHasta">{{ etiqueta }}</span>
      <span class="pin-panel__nota">{{ nota }}</span>
    </div>

    @if (!modo) {
      @if (mensaje) {
        <span class="pin-panel__mensaje" role="status" [attr.data-tono]="tono">{{ mensaje }}</span>
      }
      <button type="button" mat-raised-button class="btn ajustes-primary-btn ajustes-primary-btn--full"
        [disabled]="!!bloqueadoHasta" (click)="abrir()">
        {{ tienePin ? "Cambiar PIN" : "Definir mi PIN" }}
      </button>
    } @else {
      <form class="pin-panel__form" (ngSubmit)="guardar()" autocomplete="off">
        @if (modo === "definir") {
          <label class="pin-panel__label" for="pin-password">Contraseña de COS</label>
          <input id="pin-password" class="pin-panel__input" type="password" autocomplete="current-password" maxlength="64"
            [value]="password" [disabled]="enviando" (input)="password = $any($event.target).value" />
          <span class="pin-panel__ayuda">La misma con la que entras: así nadie define tu PIN con una sesión olvidada.</span>
        } @else {
          <label class="pin-panel__label" for="pin-actual">PIN actual</label>
          <input id="pin-actual" class="pin-panel__input pin-panel__input--pin" type="password" inputmode="numeric" autocomplete="one-time-code"
            [attr.maxlength]="PIN_MAX" [value]="pinActual" [disabled]="enviando" (input)="pinActual = digitos($event)" />
          <span class="pin-panel__ayuda">Cuenta como intento: con cinco fallos se bloquea 15 minutos.</span>
        }

        <label class="pin-panel__label" for="pin-nuevo">PIN nuevo</label>
        <input id="pin-nuevo" class="pin-panel__input pin-panel__input--pin" type="password" inputmode="numeric" autocomplete="one-time-code"
          [attr.maxlength]="PIN_MAX" [value]="pinNuevo" [disabled]="enviando" (input)="pinNuevo = digitos($event)" />

        <label class="pin-panel__label" for="pin-confirma">Confirma el PIN nuevo</label>
        <input id="pin-confirma" class="pin-panel__input pin-panel__input--pin" type="password" inputmode="numeric" autocomplete="one-time-code"
          [attr.maxlength]="PIN_MAX" [value]="pinConfirma" [disabled]="enviando" (input)="pinConfirma = digitos($event)" />

        <span class="pin-panel__ayuda">De 6 a 8 dígitos; ni un solo dígito repetido ni una escalera como 123456.</span>
        <span class="pin-panel__mensaje" role="alert" [attr.data-tono]="mensaje ? tono : 'error'">{{ mensaje || pista }}</span>

        <div class="pin-panel__botones">
          <button type="button" class="pin-panel__cancelar" [disabled]="enviando" (click)="cancelar()">Cancelar</button>
          <button type="submit" mat-raised-button class="btn ajustes-primary-btn ajustes-primary-btn--compact" [disabled]="enviando || !!problema">
            {{ enviando ? "Guardando…" : "Guardar PIN" }}
          </button>
        </div>
      </form>
    }
  </div>
}
